<template>
    <div class="request-refund-dialog">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
            <el-form-item label="Lý do hoàn cọc" prop="reason">
                <el-select
                    v-model="form.reason"
                    class="w-100"
                    placeholder="Chọn phân loại"
                    popper-class="request-refund-dialog__select-popper"
                >
                    <el-option
                        v-for="item in reasonOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    />
                </el-select>
            </el-form-item>

            <el-form-item label="Số tài khoản" prop="bankAccountNumber">
                <el-input v-model="form.bankAccountNumber" placeholder="Nhập số tài khoản"/>
            </el-form-item>

            <el-form-item label="Chủ tài khoản" prop="bankAccountName">
                <el-input v-model="form.bankAccountName" placeholder="Nhập tên chủ tài khoản"/>
            </el-form-item>

            <el-form-item label="Ngân hàng" prop="bankName">
                <el-select
                    v-model="form.bankName"
                    class="w-100"
                    filterable
                    placeholder="Chọn ngân hàng"
                    popper-class="request-refund-dialog__select-popper"
                >
                    <el-option
                        v-for="item in bankOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    />
                </el-select>
            </el-form-item>

            <el-form-item label="Ghi chú">
                <el-input
                    v-model="form.note"
                    :rows="4"
                    maxlength="500"
                    placeholder="Nhập ghi chú"
                    show-word-limit
                    type="textarea"
                />
            </el-form-item>
        </el-form>

        <div class="request-refund-dialog__footer">
            <button :disabled="submitting" class="btn btn-secondary-muted" type="button" @click="closeDialog">
                Hủy bỏ
            </button>
            <el-button
                :disabled="submitting"
                :loading="submitting"
                class="btn btn-primary text-white request-refund-dialog__btn-submit"
                type="button"
                @click="submit"
            >
                Xác nhận
            </el-button>
        </div>
    </div>
</template>

<script>
const REASON_OPTIONS = [
    {label: "Đã hoàn thành lớp chính", value: 1},
    {label: "Đã hoàn thành lộ trình bổ trợ cấp tốc", value: 2},
    {label: "Không tiếp tục chương trình bổ trợ", value: 3},
];

import {banks} from "@/assets/js/components/banks";

export default {
    name: "DialogRequestDepositRefund",
    props: {
        bankAccountNumber: {
            type: String,
            default: "",
        },
        bankAccountName: {
            type: String,
            default: "",
        },
        bankName: {
            type: String,
            default: "",
        },
        submitting: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            reasonOptions: REASON_OPTIONS,
            form: {
                reason: "",
                bankAccountNumber: "",
                bankAccountName: "",
                bankName: "",
                note: "",
            },
            rules: {
                reason: [{required: true, message: "Vui lòng chọn lý do hoàn cọc", trigger: "change"}],
                bankAccountNumber: [
                    {required: true, message: "Vui lòng nhập số tài khoản", trigger: "blur"},
                ],
                bankAccountName: [
                    {required: true, message: "Vui lòng nhập tên chủ tài khoản", trigger: "blur"},
                ],
                bankName: [{required: true, message: "Vui lòng chọn ngân hàng", trigger: "change"}],
            },
        };
    },
    computed: {
        bankOptions() {
            const options = banks.map((bank) => ({
                label: bank.name,
                value: bank.id,
            }));
            if (this.bankName && !options.some((item) => item.value === this.bankName)) {
                options.unshift({label: this.bankName, value: this.bankName});
            }
            return options;
        },
    },
    watch: {
        bankAccountNumber: {
            handler: "applyBankData",
            immediate: true,
        },
        bankAccountName: {
            handler: "applyBankData",
            immediate: true,
        },
        bankName: {
            handler: "applyBankData",
            immediate: true,
        },
    },
    methods: {
        applyBankData() {
            this.form.bankAccountNumber = this.bankAccountNumber || "";
            this.form.bankAccountName = this.bankAccountName || "";
            this.form.bankName = this.bankName || "";
        },
        closeDialog() {
            this.$emit("closeDialog");
        },
        submit() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                this.$emit("submit", {...this.form});
            });
        },
    },
};
</script>

<style scoped>
.request-refund-dialog {
    padding: 4px 4px 0;
}

.request-refund-dialog__title {
    font-size: 16px;
    font-weight: 500;
    color: #181c32;
    margin-bottom: 14px;
    line-height: 1.4;
}

.w-100 {
    width: 100%;
}

.request-refund-dialog :deep(.el-form-item) {
    margin-bottom: 14px;
}

.request-refund-dialog :deep(.el-form-item__label) {
    padding-bottom: 6px;
    line-height: 1.35;
    color: #3f4254;
    font-weight: 500;
}

.request-refund-dialog :deep(.el-input__inner),
.request-refund-dialog :deep(.el-textarea__inner) {
    border-radius: 6px;
}

.request-refund-dialog :deep(.el-input__inner) {
    height: 40px;
    line-height: 40px;
}

.request-refund-dialog :deep(.el-select .el-input__suffix) {
    right: 10px;
}

.request-refund-dialog :deep(.el-textarea__inner) {
    min-height: 90px !important;
    padding-top: 10px;
}

.request-refund-dialog :deep(.el-form-item:last-child) {
    margin-bottom: 0;
}

.request-refund-dialog__footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 18px;
    padding-top: 14px;
    border-top: 1px solid #ebedf3;
}

.btn-secondary-muted {
    background: #cacaca;
    border: none;
    color: #333;
}

.request-refund-dialog__footer .btn {
    min-width: 86px;
    height: 38px;
    border-radius: 4px;
}

.request-refund-dialog__btn-submit {
    margin: 0;
}
</style>
